import { FC } from 'react'
import Tag from 'rsuite/Tag'
import useTranslation from 'next-translate/useTranslation'

import { formatPriceNumber } from '../../utils/math'
import { CurrencySymbol } from '../../utils/types/Product'

import tagStyles from '../../styles/Tag.module.less'
import styles from '../../styles/DiscountPercentageTag.module.less'

interface DiscountPercentageTagProps {
  referencePrice: number
  currency: CurrencySymbol
  fullPrice: number
  showOnlyDiscount?: boolean
  className?: string
}

const DiscountPercentageTag: FC<DiscountPercentageTagProps> = (props) => {
  const {
    referencePrice,
    fullPrice,
    showOnlyDiscount = false,
    currency = '€',
    className = '',
  } = props

  const { t } = useTranslation('products')

  const percentage = formatPriceNumber(100 - ((referencePrice / fullPrice) * 100))
  const fullPriceString = formatPriceNumber(fullPrice)

  // Normalize both prices to string to compare
  const isDiscount = formatPriceNumber(referencePrice) !== fullPriceString

  return (
    <div className={className}>
      <Tag
        color="primary"
        className={`${styles.discount} ${
          isDiscount && !showOnlyDiscount ? styles.split : ''
        } ${tagStyles.tag} ${tagStyles['discount-tag']}`}
        size="sm"
      >
        {isDiscount ? (
          <span>{`- ${percentage}%`}</span>
        ) : (
          <span className={styles['text-wrapper']}>
            <div className={styles.background} />
            <p className={styles.text}>
              {t('Buy & save more')}
            </p>
          </span>
        )}
      </Tag>
      {isDiscount && !showOnlyDiscount && (
        <Tag
          color="primary"
          className={`${styles.price} ${tagStyles.tag} ${tagStyles['discount-tag']} margin-left-zero`}
          size="sm"
        >
          <span className={tagStyles['strike-through']}>
            {fullPriceString}
            &nbsp;
            {currency}
          </span>
        </Tag>
      )}
    </div>
  )
}

export default DiscountPercentageTag
